import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import "./UI"

// 全局样式
import "./style/global.scss";

//注册全局过滤器
import * as filters from './filter';
Object.keys(filters).forEach(k => Vue.filter(k, filters[k]));

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
